module.exports = __webpack_public_path__ + "img/jardines.c8e3dde1.svg";